import { Box, Link, Typography } from "@mui/material"
import NextLink from "next/link"
import React from "react"

const MenuItem = ({
  href,
  label,
  dataTestId,
  isActive,
  target,
}: {
  href: string
  label: string
  dataTestId: string
  isActive: boolean
  target?: React.HTMLAttributeAnchorTarget
}) => {
  return (
    <Link
      underline='none'
      component={NextLink}
      href={href}
      data-testid={dataTestId}
      className='flex flex-col items-center justify-items-start gap-1'
      target={target}
    >
      <Typography
        className={`text-sm ${isActive ? "text-primary font-semibold mt-[6px]" : "text-neutral-600 hover:text-green-mid-500"}`}
      >
        {label}
      </Typography>

      {isActive && <Box className='h-[2px] w-[22px] rounded-[1px] bg-primary' />}
    </Link>
  )
}

export default MenuItem
